import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
  @Input() isUploading: boolean = false;
  @Input() accept: string = 'application/pdf,image/jpeg,image/jpg';
  @Input() multiple: boolean | null = null;
  @Output() inputEvent = new EventEmitter<Event>();

  constructor() {}

  uploadFile(event: Event) {
    this.inputEvent.emit(event);
  }
}
